import { Navigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { CentralCardLayoutWrapper } from '@percent/cause-dashboard/common/components'
import { Spacer, Typography } from '@percent/lemonade'
import { RoutePath } from '@percent/cause-dashboard/app/routes/Routes'

type KycResultStatus = 'complete' | 'expired'

const validStatuses: KycResultStatus[] = ['complete', 'expired']

export function AgentVerificationKycResultPage() {
  const { search } = useLocation()
  const { t } = useTranslation()
  const status = new URLSearchParams(search).get('status') as KycResultStatus | null

  if (!status || !validStatuses.includes(status)) {
    return <Navigate to={RoutePath.HOME} replace />
  }

  if (status === 'expired') {
    return (
      <CentralCardLayoutWrapper>
        <Typography variant="h2">{t('agentVerificationKycResult.expired.heading')}</Typography>
        <Spacer size={6} axis="vertical" />
        <Typography>{t('agentVerificationKycResult.expired.body')}</Typography>
      </CentralCardLayoutWrapper>
    )
  }

  return (
    <CentralCardLayoutWrapper>
      <Typography variant="h2">{t('agentVerificationKycResult.complete.heading')}</Typography>
      <Spacer size={6} axis="vertical" />
      <Typography>{t('agentVerificationKycResult.complete.body')}</Typography>
    </CentralCardLayoutWrapper>
  )
}
